import React, { useState, useContext } from 'react';
import { translate } from 'react-multi-lang';
import { Layout, Row, Col, FloatButton } from 'antd'; //, Drawer

import { PerfilUsuariContext } from "../context/perfil-usuari";
import { MenuTriatContext } from "../context/menu-triat";

import MenuSuperior from '../components/MenuSuperior';
import Dashboard from './Dashboard';

// Perfil Pares / Responsables
import MenuLateralPares from '../components/MenuLateralPares';


const { Header, Sider, Content } = Layout;

function Principal(props){

  const [menuTriat, setMenuTriat] = useContext(MenuTriatContext);
  const [perfilUsuari, setPerfilUsuari] = useContext(PerfilUsuariContext);
  const [collapsed, setCollapsed] = useState(false)

  const anarMenu = ({key}) =>{
    //setPerfilUsuari(perfilUsuari => ({...perfilUsuari, menuTriat: key}));
    setMenuTriat(key);
  };


    let contingut = '';

    switch (menuTriat) {
      case 'Dashboard':
        contingut = <Dashboard/>;
        break;

//logout
      case 'Logout':
        contingut = props.t('menu.cerrar_sesion');
        sessionStorage.removeItem('jwtToken');
        sessionStorage.removeItem('jwtRefreshToken');
        sessionStorage.removeItem('perfil');
        props.logout();
        break;
      default:
        contingut = props.t('menu.cerrar_sesion');
        sessionStorage.removeItem('jwtToken');
        sessionStorage.removeItem('jwtRefreshToken');
        sessionStorage.removeItem('perfil');
        props.logout();
    }

    let menuSegonsPerfil = null;
    let colorHeader = '#fdd998';
    switch (perfilUsuari.account.perfil) {
      case 'Pare':
      case 'Professor':
        menuSegonsPerfil = <MenuLateralPares/>;
        colorHeader = '#5ab6b2';
        break;
    }

    const toggleCollapsed = () =>{
      setCollapsed(!collapsed);
    }

    return(
      <div>
        <Layout style={{backgroundColor: '#e0e0e0', height: '100vh'}}>
          <Header className="menu_superior" style={{backgroundColor: colorHeader}}> {/* #9fa8da*/}
            <MenuSuperior toggleCollapsed={toggleCollapsed} collapsed={collapsed}/>
          </Header>
          <Layout>
            {/*<Sider trigger={null} width="240" breakpoint="lg" collapsible collapsed={collapsed} className="MenuLateral">
              {menuSegonsPerfil}
            </Sider>*/}
            <Content id="contenidor" style={{backgroundColor: '#e0e0e0', borderTop: '1px solid #F5F5F5'}}>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                 {/*<BackTop visibilityHeight={250} target={() => document.getElementById('contenidor')}/>*/}
                {contingut}
                </Col>
              </Row>
              <FloatButton.BackTop visibilityHeight={250}/>
            </Content>
          </Layout>
        </Layout>
      </div>
    );
  }


export default translate(Principal);
